import React, { useEffect } from "react";
// import Layout from "./Layout/Layout";
import { createTheme, ThemeProvider } from "@mui/material";
import runOneSignal from "./utils/oneSignal/oneSignalInit";
import "./styles/theme.css";
// import "./styles/global.css";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
// import { logout } from "./actions/auth";
import { logout } from "./reduxStore/actions/auth";

import { parseJwt } from "./utils/common/commonUtilityFunctions";
import AppRoutes from "./Routes/AppRoutes";

// import OneSignal from "react-onesignal";
// import { sendToken } from "./utils/notifications";

function App() {
  const { user } = useSelector((state) => state.auth);
  const USERID = user?.userDetails?.id;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // window.alert("test success!!")

  // useEffect(() => {
  //   const checkAppInstalled = async () => {

  //     navigator.getInstalledRelatedApps().then((relatedApps) => {
  //       // console.log("relatedApps: ", relatedApps)
  //       if (relatedApps.length > 0) {
  //         alert("yes..");
  //       }
  //       for (let app of relatedApps) {
  //         console.log(app.platform);
  //         console.log(app.url);
  //         console.log(app.id);
  //         alert(app.id);
  //         window.alert(app.id);
  //       }
  //     });
  //   };

  //   checkAppInstalled();
  // }, []);

  useEffect(() => {
    window.addEventListener("load", (e) => {
      if (navigator.getInstalledRelatedApps) {
        navigator.getInstalledRelatedApps().then((apps) => {
          if (apps.length > 0) {
            console.log("app is installed, success/?!!");
          }
        });
      }
    });
  }, []);

  // useEffect(() => {
  //   if (["/login", "/register"].includes(location.pathname)) {
  //     dispatch(clearMessage()); // clear message when changing location
  //   }
  // }, [dispatch, location]);

  useEffect(() => {
    if (USERID) {
      runOneSignal();
    }
  }, [USERID]);

  const theme = createTheme({
    palette: {
      primary: {
        main:        '#016551',   // brand green
        light:       '#01a07e',
        dark:        '#04343a',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main:        '#016551',   // brand green CTA
        light:       '#EDFAF3',
        dark:        '#014d3d',
        contrastText: '#FFFFFF',
      },
      success: { main: '#016551', light: '#EDFAF3', contrastText: '#FFFFFF' },
      error:   { main: '#DC2626', light: '#FEF2F2', contrastText: '#FFFFFF' },
      warning: { main: '#F59E0B', light: '#FFFBEB', contrastText: '#1E293B' },
      info:    { main: '#0EA5E9', light: '#F0F9FF', contrastText: '#FFFFFF' },
      background: { default: '#FFFFFF', paper: '#FFFFFF' },
      text: { primary: '#0F2035', secondary: '#445C4D', disabled: '#96B09E' },
      divider: '#E2EBE6',
    },
    typography: {
      fontFamily: ['Inter', 'Rubik', '-apple-system', 'sans-serif'].join(','),
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 600 },
      h4: { fontWeight: 600 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
    },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            border: '1px solid #E2EBE6',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: { borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            '& .MuiTableCell-head': {
              backgroundColor: '#F1F5F2',
              color: '#04343a',
              fontWeight: 700,
              fontSize: '0.72rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              borderBottom: '2px solid #E2EBE6',
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: '1px solid #F1F5F2',
            color: '#0F2035',
            fontSize: '0.875rem',
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: { '&:hover': { backgroundColor: '#F4FAF6' } },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { borderRadius: 6, fontWeight: 500 },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            margin: '2px 8px',
            '&.Mui-selected': {
              backgroundColor: '#016551',
              color: '#FFFFFF',
              '& .MuiListItemIcon-root': { color: '#FFFFFF' },
              '&:hover': { backgroundColor: '#014d3d' },
            },
          },
        },
      },
    },
  });

  // useEffect(() => {
  //   if (!USERID) return;

  //   OneSignal.getUserId(function (userId) {
  //     // (Output) OneSignal User ID: 270a35cd-4dda-4b3f-b04e-41d7463a2316
  //     localStorage.setItem("one_signal_userid", userId);
  //   });

  //   OneSignal.isPushNotificationsEnabled(function (isEnabled) {
  //     if (isEnabled) {
  //       console.log("Push notifications are enabled!");
  //     } else {
  //       console.log("Push notifications are not enabled yet.");
  //       alert(
  //         "Push notifications are disabled. Please enable it on your browser to receive real time Alerts and recommendations."
  //       );
  //     }
  //   });

  //   sendToken(USERID)
  // }, [USERID]);

  // const logOut = useCallback(() => {
  //   dispatch(logout());
  // }, [dispatch]);

  // LOGOUT IF TOKEN IS EXPIRED
  // if (!!USERID) {
  //   const decodedJwt = parseJwt(user.access_token);

  //   if (decodedJwt.exp * 1000 < Date.now()) {
  //     dispatch(logout());
  //     navigate("/");
  //   }
  // }

  return (
    <ThemeProvider theme={theme}>
      {/* Add Toaster globally for toast notifications  */}
    <Toaster position="top-center"
     toastOptions={{
      duration: 4000, // 4 seconds
      success: {
        style: {
          background: '#4BB543',
          color: 'white',
        },
      },
      error: {
        style: {
          background: '#FF3333',
          color: 'white',
        },
      },
    }}
    reverseOrder={false} />
      {/* <Layout /> */}
      <AppRoutes />
    </ThemeProvider>
  );
}

export default App;
